import {
  Call,
  ApiUrl,
  PageParams,
  ParseGeneralResponse,
  setObjectToFormData,
} from './ApiUtils'

export const existingUsers = {
  fetch: (signal) => {
    const url = ApiUrl(`v1/users/list_of_existing_users`);
    return Call('get', url, '', ParseGeneralResponse, {
      responseDataKeys: { users: 'users' },
    }, true, signal);
  }
}

export const orderApprovalRulesList = {
  fetch: (PageParams, signal) => {
    const url = ApiUrl(`v2/approval_rules`);
    return Call('get', url, PageParams, ParseGeneralResponse, {
      responseDataKeys: { data: 'data',  meta: 'meta',  pending_orders_count: 'pending_orders_count' },
    }, true, signal);
  }
}

export const createOrderApprovalRule = {
  create: (params, signal) => {
    const url = ApiUrl(`v2/approval_rules`);
    return Call(
      'post',
      url,
      params,
      ParseGeneralResponse,
      {
        responseDataKeys: { order_approval_rule: 'order_approval_rule' },
        headers: {
          'Content-Type': 'application/json',
        },
      },
      true,
      signal
    );
  }
};

export const updateOrderApprovalRule = {
  update: (id, params, signal) => {
    const url = ApiUrl(`v2/approval_rules/${id}`);
    return Call(
      'put',
      url,
      params,
      ParseGeneralResponse,
      {
        responseDataKeys: { order_approval_rule: 'order_approval_rule' },
        headers: {
          'Content-Type': 'application/json',
        },
      },
      true,
      signal
    );
  }
};


export const orderListForApproval = {
  fetch: (params, signal) => {
    const url = ApiUrl(`v2/approval_rules/listing_approval_orders?page=${params.page}&per_page=${params.per_page}&order_number=${params.order_ids ? params.order_ids.join(',') : ''}`);
    return Call('get', url, params, ParseGeneralResponse, {
      responseDataKeys: { approvals_orders: 'approvals_orders', meta: 'meta' },
    }, true, signal);
  }
}

export const approveOrRejectOrder = {
  create: (params, signal) => {
    const url = ApiUrl(`v2/approval_rules/approving_orders`);

    // Merge into payload
    const payload = {
      ...params,
    };

    return Call(
      "put",
      url,
      payload,
      ParseGeneralResponse,
      {
        responseDataKeys: { order_approval_rule: "order_approval_rule" },
        headers: {
          "Content-Type": "application/json",
        },
      },
      true,
      signal
    );
  },
};


// export const approveOrRejectOrder = {
//   create: (params, signal) => {
//     const url = ApiUrl(`v2/approval_rules/approving_orders`);
//     return Call(
//       'put',
//       url,
//       params,
//       ParseGeneralResponse,
//       {
//         responseDataKeys: { order_approval_rule: 'order_approval_rule' },
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       },
//       true,
//       signal
//     );
//   }
// }